module.exports = __webpack_public_path__ + "fd22cf181e21b043c122d3e7098c7616.MP3";